import {
    Swiper,
    Navigation,
    Pagination,
    Keyboard,
    Autoplay
} from 'swiper';

Swiper.use([Navigation, Keyboard, Pagination, Autoplay]);

const sliderSections = document.querySelectorAll(".s-intro-slide");

sliderSections.forEach(slideSection => {
    const slider = slideSection.querySelector(".s-intro-slide__slider") as HTMLElement;
    const buttonPrev = ".swiper-button-prev";
    const buttonNext = ".swiper-button-next";
    const pagination = ".swiper-pagination";
    const paginationtype = "bullets" as const;
    const dataDelay = parseInt(slider.parentElement.getAttribute('data-delay')) as number;
    let delay;
    const dataSpeed = parseInt(slider.parentElement.getAttribute('data-speed')) as number;
    let speed;
    let autoplay;
    const dataAutoplay = slider.parentElement.getAttribute('data-autoplay');
    const inputs = document.querySelectorAll(".f-intro-slide .f-base");
    if (dataSpeed) {
        speed = dataSpeed
    }
    else {
        speed = 500
    }
    if (dataDelay) {
        delay = dataDelay
    }
    else {
        delay = 500
    }

    if (dataAutoplay === "true") {
        autoplay = {
            delay: delay,
            disableOnInteraction: false,
        }
    }
    else {
        autoplay = false
    }

    const containers = document.querySelectorAll(".s-intro-slide .container");

    if (slider && buttonPrev && buttonNext && pagination) {

        const swiperSettings = {
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
            pagination: {
                el: pagination,
                type: paginationtype,
                clickable: true,
            },
            autoplay: autoplay,
            loop: true,
            lazy: true,
            spaceBetween: 72,
            speed: speed,
            keyboard: true,
            draggable: true,
            allowTouchMove: true,
            slidesPerView: 1,
        };

        const swiper = new Swiper(slider, swiperSettings);

        containers.forEach(container => {
            container.addEventListener("mouseover", () => {
                swiper.autoplay.stop();
            })
        });

        containers.forEach(container => {
            container.addEventListener("mouseout", () => {
                swiper.autoplay.start();
            })

        });

        inputs.forEach(input => {
            input.addEventListener("click", () => {
                const dataMeta = swiper.realIndex as unknown
                const meta = document.querySelector("input.f-intro-slide__slide-meta") as HTMLInputElement;
                meta.value = dataMeta as string

            })
        });
    };
});
